<script>
export default {
	name: 'TransitionSimpleSlideDown',
};
</script>

<script setup>
const props = defineProps({
	// an array of Vue Refs to be watched, when any of the refs change, the transition will recalculate
	observedRefs: { type: Array, default: () => [] }, // NOT USED FOR NOW
});
const emit = defineEmits([
	// 'update:modelValue',
]);

// this variable is a "workaround" to store the html element rendered slot
let _slotRootEl = null;

const handleNestedImgsLoad = (el) => {
	/* 
		This method is required at beforeEnter because image might not be loaded,
		if so, 'el.scrollHeight' won't be accurate hence this method is to listen to the 'load' event of all nested <img>
	*/
	const allImgChildren = Array.from(el.querySelectorAll('img') || []);
	const imgChildrenMap = new Map();

	allImgChildren.forEach((img) => {
		imgChildrenMap.set(img.src, img);
	});

	if (imgChildrenMap.size !== 0) {
		el.addEventListener(
			'load',
			(event) => {
				const target = event.target;
				if (target.tagName == 'IMG') {
					imgChildrenMap.delete(target.src);
				}

				if (imgChildrenMap.size === 0) {
					enter(el);
				}
			},
			true // <-- useCapture
		);
	}
};
const beforeEnter = (el) => {
	_slotRootEl = el;
	handleNestedImgsLoad(el);
	el.style.height = '0';
};
const enter = (el) => {
	el.style.height = `${el.scrollHeight}px`;
};
const beforeLeave = (el) => {
	el.style.height = `${el.scrollHeight}px`;
};
const leave = (el) => {
	el.style.height = '0';
};

const recalculate = async () => {
	if (!_slotRootEl) return;
	_slotRootEl.style.height = '';
	await nextTick();
	enter(_slotRootEl);
};

// watch not used for now, will cause issue. This is now a concept only.
/* watch(() => props.observedRefs, (newValue, oldValue) => {
	recalculate();
}, { flush: 'post' }); */

const onTransitionEnd = (event) => {
	// clear height style after transition ends
	const el = event.target;
	el.style.height = '';
};


defineExpose({
	recalculate,
});

</script>

<template>
<transition
	name="simple-slide-down"
	@before-enter="beforeEnter"
	@enter="enter"
	@before-leave="beforeLeave"
	@leave="leave"
	@transitionend="onTransitionEnd"
>
	<slot></slot>
</transition>
</template>


<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.TransitionSimpleSlideDown {
	
}

.simple-slide-down-enter-active,
.simple-slide-down-leave-active {
	transition: all 0.2s;
}

</style>
